import { Component, ViewChild } from '@angular/core';
import {
  breadcrumb,
  link,
  stat,
} from 'src/app/admin/layout/header/header.component';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import icons from '../../../../misc/data/icons.json';
import { SelectItem } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { Message } from 'primeng/api';
import {
  ConfirmationService,
  MessageService,
  ConfirmEventType,
} from 'primeng/api';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';

import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-data-field-types',
  templateUrl: './data-field-types.component.html',
  styleUrls: ['./data-field-types.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class DataFieldTypesComponent {
  skelition = true;

  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;

  messages: Message[] = [];
  header = this.translate('Types of classifications');
  translator: TranslatorPipe = new TranslatorPipe()

  links: link[] = [
    {
      name: this.translate('Back'),
      icon: 'pi pi-arrow-left',
      link: '/admin/data',
      visible: this.permissionService.hasPermission('DATA', 'r')
    },
    {
      name: this.translate('Data classification'),
      icon: 'pi pi-file',
      link: '/admin/data/fields',
      visible: this.linkPermissions('DATA_FIELD'),
    },
    {
      name: this.translate('Types of classifications'),
      icon: 'pi pi-file-edit',
      link: '/admin/data/fields/types',
      visible: this.linkPermissions('DATA_FIELD_TYPE'),
    },
    {
      name: this.translate('data types'),
      icon: 'pi pi-list',
      link: '/admin/data/types',
      visible: this.linkPermissions('DATA_TYPE')
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('data'), link: '/admin/data' },
    { name: this.translate('Add data'), link: '/admin/data/add' },
    { name: this.translate('Organize data templates'), link: '/admin/data/templates' },
    { name: this.translate('Organization type classification'), link: '/admin/data/fields/types' },
  ];

  stats: stat[] = [];

  catdata: any[] = [];

  data: any[] = [];
  iconOptions: SelectItem[] = [];
  questions: QuestionBase<string>[] = [];

  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;

  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService
  ) { }

  linkPermissions(flag: string) {
    return this.permissionService.hasAnyPermission([{ unit: flag, flag: 'c' }, { unit: flag, flag: 'u' }, { unit: flag, flag: 'd' }]);
  }

  ngOnInit() {
    icons.forEach((icon: { i: string; n: string }) => {
      this.iconOptions.push({ label: icon.n, icon: icon.i, value: icon.i });
    });

    this.iconOptions = this.iconOptions.sort((a, b) => {
      if (a.label && b.label) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      } else {
        return 0;
      }
    });

    this.getfieldTypes();
    this.makequestion();
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  getfieldTypes = async () => {
    try {
      let res = await this.dataService.postData('field-type/get/', {});
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.catdata = res.data;

      console.log('Text===>', this.catdata, res.data);

      this.catdata?.forEach((item: any) => {
        this.data.push({
          '#': { n: item._id, i: 'pi pi-angle-left' },
          'اسم النوع': { n: item.arabic },
          الحالة: {
            n: item.active,
            i: item.active ? 'pi pi-check-circle' : 'pi pi-check-circle',
          },
          // Action: [
          //   {
          //     n: 'Delete',
          //     i: 'pi pi-times',
          //     s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
          //   },
          //   {
          //     n: 'Update',
          //     i: 'pi pi-file-edit',
          //     s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
          //   },
          // ],
        });
      });
      this.updateTypeCounts();
      this.skelition = false;
      console.log('data ou catagory => ', this.catdata, this.data);
    } catch (error) {
      console.log(error);
    }
  };

  makequestion() {
    this.questions = [
      new TextboxQuestion({
        key: 'name',
        label: 'اسم النوع باللغة الإنجليزية',
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new TextboxQuestion({
        key: 'arabic',
        label: 'اسم النوع باللغة العربية',
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'active',
        label: 'الحالة',
        options: [
          { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
          { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
        ],
        order: 4,
        className: 'col-md-12 col-sm-12 col-12',
        value: true,
        visibility: 'false',
      }),
    ];
  }

  receiveData = async ($event: any) => {
    try {
      let data = $event;
      let res = await this.dataService.postData('field-type/', data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.DynamicFormComponent.resetForm();

      console.log('test>', res.data._id);
      this.catdata.push(res.data);
      console.log('TEST DATA+=======>', this.catdata);
      this.data.unshift({
        '#': { n: res.data._id, i: 'pi pi-angle-left' },
        'اسم النوع': { n: data.arabic },
        'الحالة': {
          n: data.active,
          i: data.active ? 'pi pi-check-circle' : 'pi pi-check-circle',
        },
        // Action: [
        //   {
        //     n: 'Delete',
        //     i: 'pi pi-times',
        //     s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
        //   },
        //   {
        //     n: 'Update',
        //     i: 'pi pi-file-edit',
        //     s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
        //   },
        // ],
      });
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  UpdateData = async ($event: any) => {
    try {
      let data: any = $event;
      data._id = this.updateData._id;
      let res = await this.dataService.postData(
        'field-type/',
        data,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.updateModal = false;
      this.updateData = undefined;
      // updating in table
      const myObject = this.data.find((item) => item['#'].n === data._id);
      if (myObject) {
        (myObject['اسم النوع'].n = data.arabic),
          (myObject['اسم النوع'].i = data.icon);
        myObject['الحالة'].n = data.active;
        myObject['الحالة'].i = data.active
          ? 'pi pi-check-circle'
          : 'pi pi-check-circle';
      }

      this.data.map((e, i) => {
        if (e['#'].n === data._id) {
          this.data[i] = myObject;
          return;
        }
      });

      this.catdata.map((e, i) => {
        if (e._id === data._id) {
          this.catdata[i] = data;
          return;
        }
      });
      console.log(this.catdata);
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  actionCall($event: any) {
    console.log('==> Action Call recieved=', $event);
    switch ($event.action) {
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
          header: this.translate('Confirmation message'),
          icon: 'pi pi-exclamation-triangle',
          action: () => this.deleteCatagory($event.id),
        });
        break;
      case 'Update':
        this.updateData = this.catdata.find((item) => item._id == $event.id);
        this.updateQuestions = [
          new TextboxQuestion({
            key: 'name',
            label: 'اسم النوع باللغة الإنجليزية',
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.name,
            className: 'col-12',
          }),

          new TextboxQuestion({
            key: 'arabic',
            label: 'اسم النوع باللغة العربية',
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.arabic,
            className: 'col-12',
          }),

          new DropdownQuestion({
            key: 'active',
            label: 'الحالة',
            required: true,
            value: this.updateData?.active,
            options: [
              { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
              { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
            ],
            order: 4,
            className: 'col-12',
          }),
        ];
        console.log('Update Data ==>', this.catdata, this.updateData);
        this.updateModal = true;
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }

  deleteCatagory = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(`field-type/${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.data = this.data.filter((item) => item['#'].n !== id);
      this.catdata = this.catdata.filter((item) => item._id !== id);
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  private updateTypeCounts(): void {
    let activeCount = this.catdata?.filter((e) => e.active === true).length;
    let inactiveCount = this.catdata?.length - activeCount;
    this.stats = [
      { name: this.translate('active'), number: activeCount, icon: 'pi pi-check-circle' },
      { name: this.translate('Inactive'), number: inactiveCount, icon: 'pi pi-times-circle' },
    ];
  }
}
